import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MessageTypeEnum, SnackbarService } from '@fleet-beat/core';
import * as moment from 'moment';
import { SimpleField } from '../../abstracts/simple-field';
import { UploadFileTypeEnum } from '../../enums/type-file.enum';
import { DocumentUploadEditorModel } from '../../models/editor-upload.model';
import { FileFieldConfig } from '../../models/fields/file-field-config.model';

@Component({
  selector: 'fb-upload-field',
  templateUrl: './upload-field.component.html',
  styleUrls: ['./upload-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadFieldComponent extends SimpleField<File | DocumentUploadEditorModel[]> {
  @Input() caption: string;
  @Input() config?: FileFieldConfig;

  date: string = moment(new Date()).format('MM/DD/YYYY');
  file: File;
  logoUrl: string;
  defaultFileTypes?: string[] = [
    UploadFileTypeEnum.JPEG,
    UploadFileTypeEnum.JPG,
    UploadFileTypeEnum.PNG,
    UploadFileTypeEnum.SVG,
    UploadFileTypeEnum.PDF,
  ];

  constructor(
    protected override changeDetectorRef: ChangeDetectorRef,
    @Optional() @Self() protected override ngControl: NgControl,
    private snackBarService: SnackbarService,
  ) {
    super(changeDetectorRef, ngControl);
  }

  addFile(files: File[]): void {
    const [file]: File[] = files;
    if (!file) {
      return;
    }
    if (!(this.config.availableFileTypes || this.defaultFileTypes).includes(file.type)) {
      this.snackBarService.show({
        message: 'Wrong file type',
        type: MessageTypeEnum.ERROR,
      });
      return;
    }

    if (file.size > 1000000) {
      this.snackBarService.show({
        message: 'The image size is too large',
        type: MessageTypeEnum.ERROR,
      });
      return;
    }

    this.file = file;
    this.logoUrl = URL.createObjectURL(file);
    this.value = this.file;
  }
}
